import { Outlet } from 'react-router-dom'

import { SalaryAdvanceRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'
import CollectionsBootstrap from 'modules/salary_advance/lib/CollectionsBootstrap'

const Container = () => {
  const { data, loading } = useQuery(SalaryAdvanceRootPageDocument)

  const canSeeSalaryAdvance = data?.salaryAdvance._policies.manageSalaryAdvance.can ?? false

  if (loading) return <PageLoading />

  return (
    <AuthorizeUser authorizeFn={() => canSeeSalaryAdvance && !loading}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
